// extracted by mini-css-extract-plugin
export default {"nav":"ProductsMenu_nav__R8cOj","nav__label":"ProductsMenu_nav__label__EpEO8","nav__list":"ProductsMenu_nav__list__jEKBM","labelActive":"ProductsMenu_labelActive__YvtNK"};